export default "__VITE_PUBLIC_ASSET__3a0c2262__"